import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { queryForCommercialOperationalNotes as queryForCommercialOperationalNotesDocument } from 'src/app/graphql/commercial-services/commercial-operational-notes/query-for-commercial-operational-notes';
import {
  CommercialOperationalNoteSearchConnection,
  CommercialOperationalNoteSortOrQuery,
} from 'src/app/model/commercial-services/commercial-operational-note';
import { BaseAppSyncService } from '../base-app-sync.service';
import { CommercialOperationalNoteBuilderService } from '../builder/commercial-operational-note-builder.service';

@Injectable({
  providedIn: 'root',
})
export class CommercialOperationalNotesApiService extends BaseAppSyncService {
  private readonly _commercialOperationalNoteBuilder = inject(
    CommercialOperationalNoteBuilderService
  );

  queryForCommercialOperationalNotes(
    page: number,
    limit: number,
    query: CommercialOperationalNoteSortOrQuery,
    sort: CommercialOperationalNoteSortOrQuery
  ): Observable<CommercialOperationalNoteSearchConnection> {
    return this.query(
      queryForCommercialOperationalNotesDocument,
      { page, limit, query, sort },
      (response: any) =>
        this._commercialOperationalNoteBuilder.buildCommercialOperationalNoteSearchConnection(
          response
        ),
      'queryForCommercialOperationalNotes'
    );
  }
}
